import IdentificationContainer from "../../../Component/Application/Identification/IdentificationContainer"

const Identification = () => {
  return (
    <div className='page-body'>
      <IdentificationContainer />
    </div>
  )
}

export default Identification
